import React from "react";
import EvidencePin from "./EvidencePin";

const VARIANT_CLASS = {
  polaroid: "evidence-image--polaroid",
  screenshot: "evidence-image--screenshot",
  portrait: "evidence-image--portrait",
  logo: "evidence-image--logo",
  document: "evidence-image--document",
  clipped: "evidence-image--clipped",
};

export const EvidenceImage = ({
  src,
  alt = "",
  label,
  caption,
  variant = "screenshot",
  placeholderLabel = "IMAGE PLACEHOLDER",
  pin = "red",
  rotate = 0,
  circled = false,
  className = "",
}) => {
  return (
    <figure
      className={`evidence-image ${VARIANT_CLASS[variant] || ""} ${circled ? "is-circled" : ""} ${className}`}
      style={{ "--card-rotate": `${rotate || 0}deg` }}
    >
      {pin ? <EvidencePin color={pin} className="evidence-image-pin" /> : null}
      <div className="evidence-image-frame">
        {src ? (
          <img src={src} alt={alt} loading="lazy" decoding="async" draggable="false" />
        ) : (
          <div className="evidence-image-placeholder" role="img" aria-label={placeholderLabel}>
            <span>{placeholderLabel}</span>
          </div>
        )}
        {circled ? (
          <svg className="evidence-image-circle" viewBox="0 0 100 100" preserveAspectRatio="none" aria-hidden="true">
            <path d="M52 7C26 5 7 24 8 51c1 27 20 44 44 43 25-1 42-20 41-45C92 26 76 9 50 9c-9 0-17 2-23 6" />
          </svg>
        ) : null}
      </div>
      {(label || caption) && (
        <figcaption>
          {label ? <span className="evidence-image-label">{label}</span> : null}
          {caption ? <span className="evidence-image-caption">{caption}</span> : null}
        </figcaption>
      )}
    </figure>
  );
};

export default EvidenceImage;
